import { Header } from './Header';
import { WalletPage } from './WalletPage';

function App() {
  return (
    <>
      <Header />
      <WalletPage />
    </>
  );
}

export default App;
